import { IProductFileWithFile } from "@evennt-tech/api-v2-core";

export const getSingleProductImage = (
  productFiles: IProductFileWithFile[] = [],
  productId: string,
  primaryImageId?: string | null
) => {
  if (primaryImageId) {
    return productFiles.find((file) => file.id === primaryImageId);
  }

  return productFiles.find(
    (file) => file.productId === productId && file.position === 0
  );
};
